export const environment = {
  production: false,
  envName: 'dev',
  wwwEndpoint: 'https://dev.opale.care/',
  api: {
    publicKey: 'bc14f3a5-e0c8-40de-8e82-f2b08c07fdfd',
    endpoint: 'https://api.dev.opale.care/',
  }
}
